import { initLoadable } from '@/store/utils'
import type { Loadable } from '@/store/utils'
import type { Study, API } from '@pocketprep/types'

// This is a Mock of Quiz without the 'user' property
export type TQuizDraft = Omit<Study.Class.QuizPayload, 'user'>

/** Server 2.0 subject type with objectId for backwards compatibility */
export type ClientSubject = API.Subject & {
    objectId: string
}

/** Server 2.0 question type with objectId and re-expanded subject for backwards compatibility */
export type ClientQuestion = Omit<API.Question, 'subject'> & {
    objectId: string
    subject: ClientSubject
}

type TQotDState = {
    question: Loadable<Study.Class.QuestionJSON | ClientQuestion | null>
    globalMetric: Loadable<Study.Class.GlobalQuestionMetricJSON | null>
    sharedQotDQuizDraft: null | TQuizDraft
}

export const getInitialQotDState = (): TQotDState => {
    const sharedQotDQuizDraft = JSON.parse(localStorage.getItem('sharedQotDQuizDraft') || '{}')
    return {
        question: initLoadable(null),
        globalMetric: initLoadable(null),
        sharedQotDQuizDraft: Object.keys(sharedQotDQuizDraft).length ? sharedQotDQuizDraft : null,
    }
}

const moduleState = getInitialQotDState()

export default moduleState
